import { useSeo } from "@/hooks/useSeo";
import { Link } from "react-router-dom";

export default function Thanks() {
  useSeo({
    title: "お問い合わせありがとうございます｜株式会社GRANSTARK",
    description:
      "お問い合わせの送信が完了しました。株式会社GRANSTARKの担当者よりご連絡いたします。",
    ogUrl: "https://www.gs-granstark.com/thanks",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": "https://www.gs-granstark.com/thanks#webpage",
        url: "https://www.gs-granstark.com/thanks",
        name: "お問い合わせありがとうございます｜株式会社GRANSTARK",
        description:
          "お問い合わせの送信が完了しました。株式会社GRANSTARKの担当者よりご連絡いたします。",
        isPartOf: { "@id": "https://www.gs-granstark.com/#website" },
        publisher: { "@id": "https://www.gs-granstark.com/#business" },
        inLanguage: "ja",
      },
    ],
  });

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12 max-w-lg w-full text-center">
        <div className="w-20 h-20 mx-auto rounded-full bg-gold/10 flex items-center justify-center mb-6">
          <i className="ri-check-line text-4xl text-gold" />
        </div>

        <h1 className="text-2xl md:text-3xl font-bold text-navy mb-4">
          送信が完了しました
        </h1>

        <p className="text-gray-600 leading-relaxed mb-8">
          お問い合わせありがとうございます。
          <br />
          担当者より内容を確認の上、
          <br />
          3営業日以内にご連絡いたします。
        </p>

        <div className="bg-gold/5 rounded-xl p-6 mb-8 text-left">
          <h3 className="text-sm font-bold text-navy mb-3 flex items-center gap-2">
            <i className="ri-phone-line" />
            お電話でのご連絡も受け付けております
          </h3>
          <a
            href="tel:08045635272"
            className="text-2xl font-black text-gold hover:underline block mb-1"
          >
            TEL: 080-4563-5272
          </a>
          <p className="text-xs text-gray-500">受付時間：平日 9:00～18:00</p>
        </div>

        <div className="flex flex-col gap-3">
          <Link
            to="/"
            className="inline-block bg-gold text-navy font-bold py-3 px-6 rounded-full transition-all duration-300 hover:bg-gold-light hover:scale-[1.02] whitespace-nowrap"
          >
            トップページへ戻る
          </Link>
          <Link
            to="/business"
            className="inline-block border border-gray-300 text-gray-600 font-bold py-3 px-6 rounded-full transition-all duration-300 hover:border-navy hover:text-navy whitespace-nowrap"
          >
            事業内容を見る
          </Link>
        </div>
      </div>
    </div>
  );
}
